import React, { createContext } from 'react';
import { defaultCompanySettings } from '@innovyze/stylovyze/lib/utils/companySettings';
const defaultContext = {
    system: defaultCompanySettings?.UOM,
    decimals: 4,
};
export const UnitsContext = createContext(defaultContext);
export const UnitsProvider = ({ system = defaultContext.system, decimals = defaultContext.decimals, children, }) => {
    return (React.createElement(UnitsContext.Provider, { value: { system, decimals } }, children));
};
export default UnitsProvider;
